export default {
    captcha(state) {
        return {
            id: state.id,
            imageString: state.imageString
        };
    }
}